import styled from 'styled-components';
import Button from '~components/Button';
import { media } from '~constants/media';

export const LightGreenButton = styled(Button)`
  font-size: 11px;
  padding: 12px 18px;
  background-color: #92bf1f;
  color: white;

  &:hover {
    opacity: 0.6;
  }

  ${media.md`
      padding: 16px 24px;
      font-size: 16px;
  `}

  ${media.xl`
      font-size: 18px;
      padding: 16px 29px;
  `}
`;
